Drupal.behaviors.loginFormToggle = {
  attach() { },

  successHandler: () => {
    const getDestinationUrl = () => {
      return document.location.search
        .replace(/(^\?)/, '')
        .split('&')
        .map((p) => {
          const [name, val] = p.split('=');
          if (name === 'destination') {
            return decodeURIComponent(val);
          }
          return false;
        })
        .filter((p) => p)
        .pop();
    };

    window.location.href = window.location.origin + (getDestinationUrl() || '/user');
  },
};
